import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';
import moment from 'moment-timezone';
import { useEventsContext } from '@/pages/dashboard/EventsContext';
import useCoreEventsMetrics from "@/hooks/useCoreEventsMetrics";
import { getActualStudents } from '@/utils/studentImpact';

StudentsYear.propTypes = {
  network: PropTypes.shape({
    id: PropTypes.number
  }),
  schoolStart: PropTypes.string,
  titleOnly: PropTypes.bool
};

export default function StudentsYear(props) {
  const {network, schoolStart, titleOnly} = props;
  const {filteredEvents, isLoading, selectedSiteIds} = useEventsContext();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousEvents = useCoreEventsMetrics({
    networkId: network?.id,
    startDate: titleOnly ? undefined : previousSchoolStart,
    endDate: schoolStart,
    pageSize: 1000,
  }, {enabled: titleOnly !== true});

  if ((titleOnly !== true && previousEvents.isLoading) || isLoading) {
    return (
      <MetricLoader
        name="Students Impacted"
      />
    );
  }

  const previousCount = _.reduce(previousEvents.data, function (result, event) {
    if (!event.completed) {
      return result;
    }

    const students = getActualStudents(event);
    if (students === null) {
      return result;
    }

    const siteId = event.siteId;
    if (selectedSiteIds.length > 0 && !selectedSiteIds.includes(siteId)) {
      return result;
    }
    return result + students;
  }, 0);

  const newCount = _.reduce(filteredEvents, function (result, event) {
    if (!event.completed) {
      return result;
    }

    return result + (getActualStudents(event) || 0);
  }, 0);

  return (
    <ComparisonMetric
      name="Students Impacted"
      value={newCount}
      previousValue={previousCount}
      titleOnly={titleOnly}
    />
  );
}
